import storage from '@/utils/browser/storage'
import { httpRequest } from '@/services/http'

const _postUpsellIntent = async ({ payload }) => {
  const response = await httpRequest({
    url: `/upsell_intent/`,
    options: { method: 'POST', body: JSON.stringify(payload) }
  })

  if (response.error) {
    const error = new Error()
    error.message = response.message
    error.status = response.status
    throw error
  }

  return response
}

export default {
  post: _postUpsellIntent
}
